'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _reactImmutableProptypes = require('react-immutable-proptypes');

var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

var _bcPropTypes = require('@bibliocommons/bc-prop-types');

var _baseButtons = require('@bibliocommons/base-buttons');

var _showMoreLink = require('../../show-more-link');

var _showMoreLink2 = _interopRequireDefault(_showMoreLink);

require('../styles/SearchResults.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SearchResultItems = function (_BcReactComponent) {
  _inherits(SearchResultItems, _BcReactComponent);

  function SearchResultItems(props) {
    _classCallCheck(this, SearchResultItems);

    var _this = _possibleConstructorReturn(this, (SearchResultItems.__proto__ || Object.getPrototypeOf(SearchResultItems)).call(this, props));

    _this.bindAll('renderShowMore', 'renderDoneButton', 'renderButtons');
    return _this;
  }

  _createClass(SearchResultItems, [{
    key: 'renderDoneButton',
    value: function renderDoneButton() {
      if (this.props.displayDoneButton) {
        return _react2.default.createElement(
          _baseButtons.PrimaryButton,
          { className: 'done-button', handleClick: this.props.handleDoneButtonClicked },
          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'done_button' })
        );
      }

      return null;
    }
  }, {
    key: 'renderButtons',
    value: function renderButtons() {
      if (this.props.displayDoneButton) {
        return _react2.default.createElement(
          'div',
          { className: 'actions' },
          _react2.default.createElement(
            'div',
            null,
            this.renderShowMore()
          ),
          this.renderDoneButton()
        );
      }

      return this.renderShowMore();
    }
  }, {
    key: 'renderShowMore',
    value: function renderShowMore() {
      if (this.props.displayShowMore) {
        return _react2.default.createElement(_showMoreLink2.default, {
          pageSize: this.props.pageSize,
          itemCount: this.props.searchParams.get('totalResults'),
          page: this.props.searchParams.get('page'),
          loading: this.props.searchParams.get('fetchingNextPage'),
          handleNextPage: this.props.getNextPageSearchResults });
      }

      return _react2.default.createElement('noop', null);
    }
  }, {
    key: 'render',
    value: function render() {
      if (this.props.searchParams.get('noResultsFound') && this.props.searchResults.size === 0) {
        return _react2.default.createElement(
          'div',
          { className: 'cp-search-results' },
          _react2.default.createElement(
            'div',
            { className: 'search-results-row no-results-found' },
            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'user_list_no_results_found' })
          )
        );
      }

      if (!this.props.children || !this.props.searchResults) {
        return false;
      }

      return _react2.default.createElement(
        'ul',
        { className: 'cp-search-results' },
        this.props.children.map(function (child, i) {
          return _react2.default.createElement(
            'li',
            { key: i, className: 'search-results-row' },
            child
          );
        }),
        this.renderButtons()
      );
    }
  }]);

  return SearchResultItems;
}(_baseBcReactComponent2.default);

SearchResultItems.propTypes = {
  searchParams: _reactImmutableProptypes2.default.map,
  searchResults: _reactImmutableProptypes2.default.listOf(_bcPropTypes.listItemShape),
  pageSize: _react.PropTypes.number,
  displayShowMore: _react.PropTypes.bool,
  children: _react.PropTypes.arrayOf(_react.PropTypes.element),

  getNextPageSearchResults: _react.PropTypes.func,
  displayDoneButton: _react.PropTypes.bool,
  handleDoneButtonClicked: _react.PropTypes.func
};

SearchResultItems.defaultProps = {
  children: []
};

exports.default = SearchResultItems;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/user-list/lib/components/search-results/components/SearchResults.component.js
// module id = 1337
// module chunks = 0